import { all, apply, put, call, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import authService from '../../../services/auth'
import { AxiosResponse } from 'axios'
import {
    changePasswordFailure,
    changePasswordSuccess,
    forgotFailure,
    forgotSuccess,
    loginFailure,
    loginSuccess
} from './actions'
import { IActionType, IAxiosResponse } from '../root.types'
import { AuthTypes, IAuth, IChangePassword, IForgot } from './types'
import { open } from '../snack.bar/actions'
import { SnackBarMessageType } from '../../../components/layout/snackbar'
import { changeAvatar, changeLanguage, changeUsername } from '../layout/actions'
import { TypesUser } from '../../application/models/user/user'
import userService from '../../../services/user'
import { getUserLoggedSuccess } from '../users/actions'
import { LanguageOptions } from '../../../i18n'
import { AccessToken } from '../../application/models/auth/access.token'
import avatarService from '../../../services/avatar'

export function* authenticate(action: IActionType<AxiosResponse<IAuth>>) {
    try {
        const { data } = action.payload
        const token: AccessToken = yield apply(authService, authService.login, [data])
        yield put(loginSuccess())
      //  yield call(getUserLogged, token.sub, token.sub_type)
        yield put(push(`/app/home`))
        yield call(getUserLogged, token.sub, token.sub_type)
    } catch (err) {
        yield put(loginFailure())
    }
}

export function* forgot(action: IActionType<AxiosResponse<IForgot>>) {
    try {
        const { data } = action.payload
        yield apply(authService, authService.forgot, [data])
        yield put(forgotSuccess())
    } catch (err) {
        yield put(forgotFailure())
    }
}

export function* changePassword(action: IActionType<AxiosResponse<IChangePassword>>) {
    try {
        const { data } = action.payload
        yield apply(authService, authService.changePassword, [data])
        yield put(changePasswordSuccess())
        yield put(open(SnackBarMessageType.SUCCESS, 'AUTH.CHANGE_PASSWORD.SNACKBAR.TITLE', 'AUTH.CHANGE_PASSWORD.SNACKBAR.MESSAGE'))
    } catch (err) {
        yield put(changePasswordFailure())
    }
}
export function* getUserLogged(userId: string | undefined, type: string | undefined) {
    if (userId && type) {
        try {
            const response: IAxiosResponse<any> = yield apply(userService, userService.getById, [userId, TypesUser[type.toUpperCase()]])
            yield put(getUserLoggedSuccess(response.data))
            yield put(changeLanguage(LanguageOptions.PT_BR))
            yield put(changeUsername(response.data.name))
        } catch (e) {
            yield put(changeLanguage(LanguageOptions.PT_BR))
            yield put(changeUsername('...'))
        }
        try {
            const avatar: any = yield apply(avatarService, avatarService.get, [userId, "users", true])
            yield put(changeAvatar(avatar))
        } catch (e) {
            yield put(changeAvatar(''))
        }
    }
}

export default function* authSaga() {
    return yield all([
        takeLatest(AuthTypes.LOGIN_REQUEST, authenticate),
        takeLatest(AuthTypes.FORGOT_REQUEST, forgot),
        takeLatest(AuthTypes.CHANGE_PASSWORD_REQUEST, changePassword)
    ])
}
